import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useRef, useCallback, useMemo, useEffect } from 'react';
import invariant from 'invariant';
import { useReactFormsContext, INIT_FIELD_ARRAY, UPDATE_FIELD_ARRAY, TERMINATE_FIELD_ARRAY } from '../react-forms';
import { uuid } from '../utils';
import { get, findIndex, memoize } from 'lodash';

var _push = function _push() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var copy = _toConsumableArray(array);

  copy.push(field);
  return copy;
};

var _pop = function _pop() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var copy = _toConsumableArray(array);

  copy.pop();
  return copy;
};

var _unshift = function _unshift() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var copy = _toConsumableArray(array);

  copy.unshift(field);
  return copy;
};

var _swap = function _swap() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var indexA = arguments.length > 1 ? arguments[1] : undefined;
  var indexB = arguments.length > 2 ? arguments[2] : undefined;

  var copy = _toConsumableArray(array);

  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};

var _move = function _move() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var from = arguments.length > 1 ? arguments[1] : undefined;
  var to = arguments.length > 2 ? arguments[2] : undefined;

  var copy = _toConsumableArray(array);

  var value = copy[from];

  _spliceInstanceProperty(copy).call(copy, from, 1);

  _spliceInstanceProperty(copy).call(copy, to, 0, value);

  return copy;
};

var _insert = function _insert() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var index = arguments.length > 1 ? arguments[1] : undefined;
  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var copy = _toConsumableArray(array);

  _spliceInstanceProperty(copy).call(copy, index, 0, field);

  return copy;
};

var _replace = function _replace() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var index = arguments.length > 1 ? arguments[1] : undefined;
  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var copy = _toConsumableArray(array);

  copy[index] = field;
  return copy;
};

var _remove = function _remove() {
  var _context;

  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var index = arguments.length > 1 ? arguments[1] : undefined;
  return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(_sliceInstanceProperty(array).call(array, 0, index)), _toConsumableArray(_sliceInstanceProperty(array).call(array, index + 1, array.length)));
};

function getFieldIndex(fields, id) {
  var index = findIndex(fields, function (field) {
    var _field$field;

    return (field === null || field === void 0 ? void 0 : (_field$field = field.field) === null || _field$field === void 0 ? void 0 : _field$field.id) === id;
  });
  invariant(index !== -1, "Can not find field with ID \"".concat(id, "\"."));
  return index;
}

var createFieldActions = memoize(function (fieldId, fieldArrayId, dispatch) {
  var swap = function swap(otherIndex) {
    dispatch({
      id: fieldArrayId,
      type: UPDATE_FIELD_ARRAY,
      payload: {
        fields: function fields(_fields) {
          var index = getFieldIndex(_fields, fieldId);

          _swap(_fields, index, otherIndex);
        }
      }
    });
  };

  var move = function move(to) {
    dispatch({
      id: fieldArrayId,
      type: UPDATE_FIELD_ARRAY,
      payload: {
        fields: function fields(_fields2) {
          var index = getFieldIndex(_fields2, fieldId);

          _move(_fields2, index, to);
        }
      }
    });
  };

  var remove = function remove() {
    dispatch({
      id: fieldArrayId,
      type: UPDATE_FIELD_ARRAY,
      payload: {
        fields: function fields(_fields3) {
          var index = getFieldIndex(_fields3, fieldId);
          return _remove(_fields3, index);
        }
      }
    });
  };

  return {
    swap: swap,
    move: move,
    remove: remove
  };
});

function createFieldArrayActions(fieldArrayId, createOrUpdateField, dispatch) {
  var push = function push(field) {
    dispatch({
      id: fieldArrayId,
      type: UPDATE_FIELD_ARRAY,
      payload: {
        fields: function fields(_fields4) {
          return _push(_fields4, createOrUpdateField(field, _fields4.length));
        }
      }
    });
  };

  var pop = function pop() {
    dispatch({
      id: fieldArrayId,
      type: UPDATE_FIELD_ARRAY,
      payload: {
        fields: function fields(_fields5) {
          return _pop(_fields5);
        }
      }
    });
  };

  var unshift = function unshift(field) {
    dispatch({
      id: fieldArrayId,
      type: UPDATE_FIELD_ARRAY,
      payload: {
        fields: function fields(_fields6) {
          return _unshift(_fields6, createOrUpdateField(field, 0));
        }
      }
    });
  };

  var insert = function insert(i, field) {
    dispatch({
      id: fieldArrayId,
      type: UPDATE_FIELD_ARRAY,
      payload: {
        fields: function fields(_fields7) {
          return _insert(_fields7, i, createOrUpdateField(field, i));
        }
      }
    });
  };

  var replace = function replace(i, field) {
    dispatch({
      id: fieldArrayId,
      type: UPDATE_FIELD_ARRAY,
      payload: {
        fields: function fields(_fields8) {
          return _replace(_fields8, i, createOrUpdateField(field, i));
        }
      }
    });
  };

  var swap = function swap(index, otherIndex) {
    dispatch({
      id: fieldArrayId,
      type: UPDATE_FIELD_ARRAY,
      payload: {
        fields: function fields(_fields9) {
          return _swap(_fields9, index, otherIndex);
        }
      }
    });
  };

  var move = function move(from, to) {
    dispatch({
      id: fieldArrayId,
      type: UPDATE_FIELD_ARRAY,
      payload: {
        fields: function fields(_fields10) {
          return _move(_fields10, from, to);
        }
      }
    });
  };

  var remove = function remove(index) {
    dispatch({
      id: fieldArrayId,
      type: UPDATE_FIELD_ARRAY,
      payload: {
        fields: function fields(_fields11) {
          return _remove(_fields11, index);
        }
      }
    });
  };

  return {
    push: push,
    pop: pop,
    unshift: unshift,
    insert: insert,
    replace: replace,
    swap: swap,
    move: move,
    remove: remove
  };
}

function useFieldArray(name, _ref) {
  var _get, _fieldArrays$id$curre, _fieldArrays$id$curre2;

  var propId = _ref.id,
      initialValue = _ref.initialValue,
      sendImmediate = _ref.sendImmediate,
      onFocus = _ref.onFocus,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      validate = _ref.validate,
      rest = _objectWithoutProperties(_ref, ["id", "initialValue", "sendImmediate", "onFocus", "onChange", "onBlur", "validate"]);

  var _useReactFormsContext = useReactFormsContext(),
      initialValues = _useReactFormsContext.initialValues,
      fieldArrays = _useReactFormsContext.fieldArrays,
      resetFieldArray = _useReactFormsContext.resetFieldArray,
      formDispatch = _useReactFormsContext.dispatch;

  var id = useRef(propId !== null && propId !== void 0 ? propId : uuid()); // TODO: Find a better name for field properties

  var createOrUpdateField = useCallback(function (field, index) {
    var _context2;

    var fieldId = (field === null || field === void 0 ? void 0 : field.id) || uuid();
    return {
      field: _objectSpread(_objectSpread({
        initialValue: initialValue !== undefined ? initialValue : '',
        sendImmediate: sendImmediate,
        onFocus: onFocus,
        onChange: onChange,
        onBlur: onBlur,
        validate: validate
      }, field), {}, {
        id: fieldId,
        key: fieldId,
        name: _concatInstanceProperty(_context2 = "".concat(name, ".")).call(_context2, index)
      }),
      actions: createFieldActions(fieldId, id.current, formDispatch)
    };
  }, [name, initialValue, sendImmediate, onFocus, onChange, onBlur, validate, formDispatch]);
  var getFieldProps = useCallback(function (_ref2) {
    var field = _ref2.field;
    return _objectSpread(_objectSpread({}, rest), field);
  }, [rest]); // We only care about the initial fields on
  // when the FieldArray mounts for the first time
  // or when it's name changes

  var initialFieldValues = (_get = get(initialValues, name)) !== null && _get !== void 0 ? _get : [];
  var initialFields = useMemo(function () {
    return _mapInstanceProperty(initialFieldValues).call(initialFieldValues, function (value, index) {
      return createOrUpdateField({
        initialValue: value
      }, index);
    });
  }, [name]); // eslint-disable-line

  var actions = useMemo(function () {
    return _objectSpread(_objectSpread({}, createFieldArrayActions(id.current, createOrUpdateField, formDispatch)), {}, {
      getFieldProps: getFieldProps,
      reset: function reset(values) {
        resetFieldArray(id.current, values);
      }
    });
  }, [createOrUpdateField, formDispatch, getFieldProps, resetFieldArray]); // Send the initial fields that we
  // have made using the form initialValues
  // then ignore any changes
  // We deal with resetting the Field Array
  // state in the top level form context

  useEffect(function () {
    var fieldArrayId = id.current;
    formDispatch({
      id: fieldArrayId,
      type: INIT_FIELD_ARRAY,
      payload: {
        name: name,
        fields: initialFields,
        createOrUpdateField: createOrUpdateField
      }
    });
    return function () {
      formDispatch({
        id: fieldArrayId,
        type: TERMINATE_FIELD_ARRAY
      });
    };
  }, [name]); // eslint-disable-line
  // Shouldn't have to update this updater
  // function very much at all but if any of
  // the field specific props passed to the
  // Field Array are updated then we want to make sure
  // we are reflecting those updates in the props
  // passed back down to each Field from the FieldArray
  // This does mean that we can't pass inline functions
  // for onFocus, onChange and onBlur unless
  // the user is fine with more renders than neccessary

  useEffect(function () {
    formDispatch({
      id: id.current,
      type: UPDATE_FIELD_ARRAY,
      payload: {
        createOrUpdateField: createOrUpdateField
      }
    });
  }, [createOrUpdateField, formDispatch]); // Return the state directly from the form context
  // so that we can skip at least one update by not
  // keeping state in here and passing it back up

  var fields = (_fieldArrays$id$curre = fieldArrays === null || fieldArrays === void 0 ? void 0 : (_fieldArrays$id$curre2 = fieldArrays[id.current]) === null || _fieldArrays$id$curre2 === void 0 ? void 0 : _fieldArrays$id$curre2.fields) !== null && _fieldArrays$id$curre !== void 0 ? _fieldArrays$id$curre : initialFields;
  return [fields, actions];
}

export { useFieldArray };